<era-devices-state-badge-ui [count]="count$ | async"
                            [state]="state$ | async"></era-devices-state-badge-ui>